<template>
  <div class="bg-container page bc-img auth-screen auth-screen--login">
    <div class="bg-wrapper bc-body bc-box bc-img">
      <div class="login">
        <van-nav-bar class="nav-bar" :title="$t('auth.login')">
          <template #left>
            <van-icon name="arrow-left" color="#fff" @click="back()" />
          </template>
        </van-nav-bar>
        <div class="wrapper">
          <div class="beauty-motion" aria-hidden="true">
            <img src="../../assets/bc-img/n1.jpg" alt="" class="beauty-img beauty-img-one" />
            <img src="../../assets/bc-img/n2.jpg" alt="" class="beauty-img beauty-img-two" />
            <img src="../../assets/bc-img/n3.jpg" alt="" class="beauty-img beauty-img-three" />
          </div>
          <div class="icon-top">
            <div class="top1">
              <img src="../../assets/bc-img/logo.png" alt="SweetLove" class="brand-logo" />
            </div>
            <div class="top2">{{ $t("auth.login") }}</div>
            <div class="top3">{{ $t("auth.login") }}</div>
          </div>
          <div class="loginForm">
            <div class="input1">
              <label>{{ $t("auth.login") }}</label>
              <van-field
                v-model="username"
                :border="false"
                clearable
                class="input"
                :placeholder="$t('auth.username_place')"
              />
            </div>
            <div class="input1">
              <label>{{ $t("auth.Login_password") }}</label>
              <van-field
                v-model="password"
                :border="false"
                :type="passwordType"
                class="input"
                :placeholder="$t('auth.pwd_place')"
              >
                <template slot="right-icon">
                  <van-icon
                    :name="passwordType === 'password' ? 'closed-eye' : 'eye-o'"
                    @click="switchPasswordType"
                  />
                </template>
              </van-field>
            </div>

            <div class="text-center login-tool">
              <div class="register-link" role="button" tabindex="0" @click="toRegister()" @keydown.enter="toRegister()">
                <span>沒有帳號？立即註冊</span>
              </div>
            </div>
            <van-button
              class="login-btn"
              type="primary"
              size="normal"
              @click="doLogin()"
            >
              {{ $t("auth.login") }}
            </van-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  model: {
    prop: "inputValue",
    event: "input",
  },
  props: {
    /**
     * 当前输入的值
     */
    inputValue: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      username: "",
      lang: "en_us",
      password: this.inputValue,
      passwordType: "password",
    };
  },
  mounted() {
    // localStorage.setItem("lang", "ko_hy");
    this.lang = localStorage.getItem("lang") || "zh_tw";
  },
  methods: {
    tallkf(){
    },
    switchPasswordType() {
      this.passwordType =
        this.passwordType === "password" ? "text" : "password";
    },
    back() {
      return window.history.back();
    },
    toRegister() {
      this.$router.push("Register");
    },
    doLogin() {
      if (
        this.username === "" ||
        this.username === null ||
        this.username === undefined
      ) {
        this.$toast(this.$t("auth.username_place"));
        return false;
      }
      if (
        this.password === "" ||
        this.password === null ||
        this.password === undefined
      ) {
        this.$toast(this.$t("auth.pwd_place"));
        return false;
      }
      this.$http({
        url: "member_login",
        method: "post",
        data: {
          username: this.username,
          password: this.password,
          lang: this.lang,
        },
      }).then((res) => {
        if (res.code === 200) {
          console.info(res.msg);
          this.$toast.success(res.msg);
          localStorage.setItem("token", res.data.id);
          this.$router.push("Mine");
        } else {
          this.$toast(res.msg);
        }
      });
    },
  },
  created() {
    if (localStorage.getItem("token")) {
      return window.history.back();
    }
  },
};
</script>

<style lang='less' scoped>
@import "../../assets/css/base.less";
::v-deep .van-field__control {
  &::placeholder {
    color: #444 !important;
  }
}
::v-deep .van-nav-bar__title {
  display: none !important;
}
::v-deep .van-nav-bar .van-icon {
  color: #bbbbbb !important;
  padding: 0.8rem;
  border: 1px solid #444;
  border-radius: 1rem;
}
::v-deep .van-nav-bar__content {
  background: none !important;
}
.icon-top {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  height: auto;
  padding: 1.5rem 1.5rem;
  background: linear-gradient(to bottom right, #33251a, #1b1435);
  opacity: 0.85;
  margin-top: 1.2rem;
  border: 1px solid #444;
  border-radius: 1rem;
  .top1 {
    display: flex;
    align-items: center;
    min-height: 2.4rem;
  }
  .brand-logo {
    display: block;
    width: 8.8rem;
    max-width: 64vw;
    height: auto;
  }
  .top2 {
    color: #d2ab84;
    font-weight: lighter !important;
    margin: 0.5rem 0;
  }
  .top3 {
    color: #fff;
    font-size: 2rem;
  }
}
.bc-box {
  background: rgba(0, 0, 0, 0.4);
}
.bc-body {
  padding: 1rem;
}
.bc-img {
  position: absolute;
  inset: 0;
  background: linear-gradient(180deg, rgba(0, 0, 0, 0.18), rgba(0, 0, 0, 0.9)),
    url("/img/bg.e6263671.jpg") no-repeat center top;
  filter: saturate(1.05);
  background-size: cover, auto 60%;
  animation: authBgSway 4.8s ease-in-out infinite alternate;
  will-change: background-position;
}
@keyframes authBgSway {
  from {
    background-position: center center, calc(50% - 1rem) top;
  }
  to {
    background-position: center center, calc(50% + 1rem) top;
  }
}
.beauty-motion {
  position: relative;
  height: 7rem;
  margin: 0.6rem 0 0.8rem;
  border-radius: 1.1rem;
  overflow: hidden;
  border: 1px solid rgba(244, 197, 125, 0.38);
  background: #110d13;
  box-shadow: 0 0.8rem 2rem rgba(0, 0, 0, 0.35);
}
.beauty-motion::after {
  content: "";
  position: absolute;
  inset: 0;
  background:
    linear-gradient(90deg, rgba(12, 8, 12, 0.2), rgba(12, 8, 12, 0.66)),
    linear-gradient(180deg, rgba(255, 206, 142, 0.12), rgba(0, 0, 0, 0.45));
}
.beauty-img {
  position: absolute;
  top: 0;
  width: 48%;
  height: 100%;
  object-fit: cover;
  filter: saturate(1.08) contrast(1.04);
  animation: beautyDrift 8s ease-in-out infinite alternate;
}
.beauty-img-one {
  left: 0;
}
.beauty-img-two {
  left: 28%;
  animation-delay: -2s;
}
.beauty-img-three {
  right: 0;
  animation-delay: -4s;
}
@keyframes beautyDrift {
  from {
    transform: scale(1.04) translate3d(-0.35rem, 0, 0);
  }
  to {
    transform: scale(1.12) translate3d(0.35rem, 0, 0);
  }
}
.login {
  height: 100%;
}
.login .wrapper {
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}
.login .wrapper .loginForm {
  padding: @pd1;
  border-radius: 2rem;
  border: 1px solid #2a2a2a;
  margin-top: 1.5rem;
  label {
    display: inline-block;
    margin: 0;
    color: #fff;
    font-weight: lighter !important;
  }
  .input1 {
    border-radius: 1rem;
    border: 1px solid #2a2a2a;
    padding: 1rem 1rem;
    background-color: #111015;
    margin-bottom: 1rem;
  }
}
.login .wrapper .loginForm .input {
  padding: 0 20px;
  background: @input_bg;
  border-radius: @br1;
  text-align: center;
  line-height: 80px;
  font-size: 30px;
  border: 1px solid #2a2a2a;
  margin-top: 1rem;
  /deep/ input {
    color: #ccc;
  }
}
::v-deep .van-field__right-icon .van-icon {
  font-size: 50px;
}
::v-deep .van-icon {
  font-size: 50px;
}
.login .wrapper .loginForm .login-btn {
  margin: @md1 0;
  width: 100%;
  height: 100px;
  border-radius: @br1*2;
  color: @black;
  background: linear-gradient(to right, #f4c57d, #f5a452);
  font-size: 30px;
  font-weight: bolder;
  border: none;
}
.login-tool {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;
  margin-top: 0.5rem;
  & > div {
    color: #d2ab84;
  }
  & > div:nth-of-type(1) {
    color: #fff;
  }
}

.bg-container.page {
  position: relative !important;
  min-height: 100vh;
  height: auto;
  overflow-x: hidden;
  overflow-y: auto;
  background: #000;
}
.bg-container.bc-img {
  background-image: url("/img/bg.e6263671.jpg");
  background-repeat: no-repeat;
  background-position: 0% center;
  background-size: auto 100%;
  filter: none;
  animation: authBgAutoScroll 18s ease-in-out infinite alternate;
}
.bg-wrapper.bc-img {
  position: relative;
  min-height: 100vh;
  height: 100%;
  background: rgba(0, 0, 0, 0.14);
  filter: none;
  animation: none;
}
.bc-box {
  background: transparent;
}
.bc-body {
  padding: 0 2.2rem;
}
@keyframes authBgAutoScroll {
  from {
    background-position: 0% center;
  }
  to {
    background-position: 100% center;
  }
}
.beauty-motion,
.icon-top {
  display: none;
}
.login .wrapper {
  min-height: calc(100vh - 100px);
  height: auto;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  box-sizing: border-box;
  padding-top: 38vh;
  padding-bottom: 2rem;
  overflow-y: auto;
}
.login .wrapper .loginForm {
  width: 100%;
  max-width: 26rem;
  margin: 0 auto;
  padding: 0;
  border: none;
  border-radius: 0;
  background: transparent;
}
.login .wrapper .loginForm label {
  display: none;
}
.login .wrapper .loginForm .input1 {
  margin-bottom: 0.9rem;
  padding: 0;
  border: none;
  border-radius: 0;
  background: transparent;
}
.login .wrapper .loginForm .input {
  height: 3.8rem;
  min-height: 3.8rem;
  padding: 0 1.35rem;
  margin-top: 0;
  border: none;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.94);
  box-shadow: 0 0.55rem 1.4rem rgba(0, 0, 0, 0.16);
  line-height: normal;
  font-size: 1rem;
  display: flex;
  align-items: center;
}
::v-deep .loginForm .van-field__body {
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
}
::v-deep .loginForm .van-field__control {
  color: #222 !important;
  font-size: 1rem;
  text-align: center;
  height: 1.4rem;
  line-height: 1.4rem;
  padding: 0;
}
::v-deep .loginForm .van-field__control::placeholder {
  color: #bdbdbd !important;
}
::v-deep .loginForm .van-field__right-icon {
  height: 100%;
  display: flex;
  align-items: center;
}
::v-deep .loginForm .van-field__right-icon .van-icon {
  color: #9a9a9a !important;
  font-size: 1.4rem;
}
.login-tool {
  justify-content: center;
  margin: 0.15rem 0 1.15rem;
}
.login-tool > div:first-child {
  display: block;
}
.login-tool > div {
  color: #fff;
  font-size: 0.82rem;
  text-shadow: 0 2px 10px rgba(0, 0, 0, 0.45);
}
.login .wrapper .loginForm .login-btn {
  width: 100%;
  height: 3.8rem;
  margin: 0;
  border: none;
  border-radius: 999px;
  background: linear-gradient(90deg, #7c24e7 0%, #d8209d 100%);
  box-shadow: 0 0.7rem 1.5rem rgba(124, 36, 231, 0.26);
  color: #fff;
  font-size: 1.05rem;
  font-weight: 700;
}
::v-deep .van-nav-bar__content {
  background: transparent !important;
}
::v-deep .van-nav-bar .van-icon {
  width: 2.7rem;
  height: 2.7rem;
  padding: 0;
  border: none;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.86);
  color: #222 !important;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.35rem;
}
.bg-wrapper.bc-img,
.bc-body,
.login .wrapper,
.login .wrapper .loginForm,
.login .wrapper .loginForm .input,
.login .wrapper .loginForm .login-btn {
  box-sizing: border-box;
}
.bg-wrapper.bc-img,
.login .wrapper {
  width: 100%;
}
.login .wrapper .loginForm {
  position: relative;
  top: auto;
  left: auto;
  right: auto;
  width: 84vw;
  max-width: 84vw;
  margin: 0 auto;
}
.login .wrapper .loginForm .input {
  width: 100%;
  max-width: 100%;
  display: flex;
}
.login .wrapper .loginForm .login-btn {
  width: 100%;
  max-width: 100%;
  display: block;
}
.register-link { display: block !important; padding: .35rem .75rem; border-radius: 999px; background: rgba(0,0,0,.48); text-decoration: underline; }
</style>
